import { useEffect, useState } from 'react'

export type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

/**
 * Counts down from a fixed number of seconds, restarting the window when it hits zero.
 */
export function useCountdown(initialSeconds: number): TimeLeft {
  const [remaining, setRemaining] = useState<number>(initialSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? initialSeconds : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [initialSeconds])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
